import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { faChartPie } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/core/services/auth/auth.service';
import { FacturacionService } from 'app/core/services/facturacion/facturacion.service';
import { columnHeader } from 'app/shared/factoring-datatable/factoring-datatable.component';
import { FacturaModalComponent } from '../../modals/factura-modal/factura-modal.component';
import { NotaCreditoModalComponent } from '../../modals/nota-credito-modal/nota-credito-modal.component';

@Component({
  selector: 'app-facturas-pendientes',
  templateUrl: './facturas-pendientes.component.html',
  styleUrls: ['./facturas-pendientes.component.css']
})
export class FacturasPendientesComponent implements OnInit {
  faChartPie = faChartPie
  public rowData: any[] = [];
  public loadingTable: boolean = false;
  public columnDefs: columnHeader[];
  public pageTableActual: number;
  public pageTableTotal: number;
  public pageTablePerPages: number = 10;
  public pageTablePages: number[];
  public user: any;
  public identidad: any = {};
  public searchstring: string = '';
  public canCreate: boolean = false;
  listSelect: any[] = [];
  count:number = 0;

  public todoSelect: boolean = false;
  public selectionRows: any[]; //! This buscar que es
  public preselected: any[] = [];

  @Input() tableSelectable: boolean = false;
  @Input() set refresh(value) {
    this.tableSelectable = false;
    this.obtenerFacturas();
  }

  @Output() ocultarBtn = new EventEmitter();

  estados: any[] = [];
  tipos: any[] = [];

  constructor(
    private facturacionService: FacturacionService,
    private modalService: NgbModal,
    private authService: AuthService,
  ) {
    this.user = this.authService.user;
  }

  ngOnInit(): void {

    this.ocultarBtn.emit(true)

    let estados = this.facturacionService.obenerEstados();
    let tipos = this.facturacionService.obtenerTipos();
    let concepto = this.facturacionService.obtenerConceptos();
    Promise.all([estados, tipos,concepto ]).then(resp => {
      this.estados = resp[0]['results'];
      this.tipos = resp[1]['results'];
      let concepto1 = resp[2]['results'];
      this.initVars(this.estados, this.tipos, concepto1);
    }, err => {
      console.error(err);

    });
    
    this.obtenerFacturas();
    
  }

  obtenerFacturas(
    page = 1,
    page_size = 10,
    referencia = '',
    tipo_pagador = '',
    tipo = '',
    estado = '1,4,6',
    asistente_cobranzas = '',
    pagador_nombre = '',
    concepto = '',
    fecha_pago__gte = '' ,
    fecha_pago__lte = '',
    fecha_facturado__gte = '' ,
    fecha_facturado__lte = '',
    operacion = '',
    usuario_creador = '',
    cuenta_cobrar = '',
  ) {

    // this.user.isAsistenteCobranzas ? this.user.id : ''
    this.facturacionService.obtenerFacturas(
      referencia, tipo_pagador, tipo, estado,
      '',
      page, page_size, '', '', pagador_nombre, concepto , fecha_pago__gte, fecha_pago__lte, '', '', operacion, usuario_creador, '1', '', 
      this.user.isOficialDeNegocio || this.user.isLiderDeEquipo ? this.user.id : '',  cuenta_cobrar
    ).then((resp:any) => {
      console.log( 'Respueta', resp )
      this.loadTable(resp);
      // this.initVars(this.estados, this.tipos);
    }, err => {
      console.error(err);

    });
  }

  loadTable(data) {
    this.rowData = data.results
    this.pageTableActual = data.page_number
    this.pageTableTotal = data.count
    this.pageTablePerPages = data.per_page
    this.pageTablePages = []
    for (let index = 0; index < data.num_pages; index++) {
      this.pageTablePages.push(index)
    }
  }

  initVars(estados = [], tipos = [], concepto = []) {
    let columns = [
      {
				headerName: '',
				field: '',
				sortable: true,
			},
      {
				headerName: 'Creado Por',
				field: 'usuario_creador',
				class: 'text-center',
				sortable: true,
        filterable: true,
        filterProp: 'usuario_creador',
        filterInput: true,
			},
      {
        headerName: 'Nro CxC',
        field: 'cuenta_cobrar',
        class: 'text-center',
        sortable: true,
        filterable: true,
        filterProp: 'cuenta_cobrar',
        filterInput: true,
      },
      {
        headerName: 'Tipo Doc.',
        field: 'tipo_descripcion',
        class: 'text-center',
        sortable: true,
        filterable: true,
        filterProp: 'tipo',
        filterSelectItems: tipos,
        filterItemsProps: {
          value: 'id',
          label: 'descripcion'
        },
      },
      {
        headerName: 'Cobrar a',
        field: 'pagador_nombre',
        class: 'text-center',
        sortable: true,
        filterable: true,
        filterProp: 'pagador_nombre',
        filterInput: true,
      },
      {
        headerName: 'Fecha de Pago',
        field: 'fecha_pago',
        class: 'text-center',
        pipe: 'date',
        sortable: true,
        filterable: true,
        filterDate: true,
      },
      {
        headerName: 'Concepto',
        field: 'concepto',
        class: 'text-center',
        sortable: true,
				filterable: true,
				filterProp: 'concepto',
				filterSelectItems: concepto,
				filterItemsProps: {
					value: 'id',
					label: 'descripcion'
				},
      },
      {
        headerName: 'Monto',
        field: 'monto',
        class: 'text-center',
        pipe: 'currency',
        moneda: 'moneda',
        sortable: true,
      },
      {
        headerName: 'IGV',
        field: 'igv',
        class: 'text-center',
        pipe: 'currency',
        moneda: 'moneda',
        sortable: true,
      },
      {
        headerName: 'Total',
        field: 'total',
        class: 'text-center',
        pipe: 'currency',
        moneda: 'moneda',
        sortable: true,
      },
      {
        headerName: 'Estado',
        field: 'estado_descripcion',
        filterProp: 'estado',
        sortable: true,
        class: 'text-center',
        filterable: true,
        filterSelectItems: estados,
        filterItemsProps: {
          value: 'id',
          label: 'descripcion'
        },
      },
      {
				headerName: 'Operación',
				field: 'operacion',
				class: 'text-center',
        sortable: true,
        filterable: true,
				filterProp: 'operacion',
				filterInput: true,
			},
      {
        headerName: 'Glosa',
        field: 'glosa',
        class: 'text-center',
        sortable: true,
      },
    ];

    this.columnDefs = columns;
  }

  goToPage({ page, per_page, filtros }) {

    let listEstados = (filtros.estado) ? `${filtros.estado}` : '1,4,6';
    this.obtenerFacturas(page, per_page, '', '', filtros.tipo, listEstados, '', filtros.pagador_nombre, filtros.concepto,
    filtros.fecha__gte,
    filtros.fecha__lte, '' , '', filtros.operacion, filtros.usuario_creador, filtros.cuenta_cobrar);

    this.todoSelect = false;
    this.preselected = [];
    this.listSelect = [];
  }

  tableEditEvent(row) {

    let modalRef;

    if (row.tipo == 2) {
      modalRef = this.modalService.open(NotaCreditoModalComponent, {
        size: 'xl',
        backdrop: 'static'
      });
    } else {
      modalRef = this.modalService.open(FacturaModalComponent, {
        size: 'xl'
      });
    }

    // const modalRef = this.modalService.open(FacturaModalComponent, {
    //   size: 'xl'
    // });

    modalRef.componentInstance.facturaIn = row;

    modalRef.result.then((result) => {
      console.log(result);
      if (result) {
        this.obtenerFacturas();
      }
    }, (reason) => {
      console.log(reason);
    });
  }

  destroy(row) {

  }

  checkEvent(row) {
    this.listSelect = row;
    this.evalCheck();
  }

  async enviarDacturas() {

    // await this.listSelect.forEach(async element => {
    //   await this.facturacionService.facturar([element])
    // });

    for (const element of this.listSelect) {
      const resp = await this.facturacionService.facturar(element)
      console.log(resp);
    }

    // this.facturacionService.facturar(this.listSelect).then((res) => {
    //   console.log(res);
    //   this.obtenerFacturas();
    // }, err => {
    //   console.error(err);

    // });
    this.obtenerFacturas();
  }

  get canAdd() {
		const perfilesPermitidos = [
		  this.authService.perfil.perfilAdmin,
		  this.authService.perfil.perfilJefeDeOperacionesID,
		//   this.authService.perfil.perfilAnalistaOperacionesID,
		  this.authService.perfil.perfilAsistenteCobranzasID,
		//   this.authService.perfil.perfilAnalistaOperacionesID,
		  this.authService.perfil.perfilGerenciaComercialID,
		  this.authService.perfil.perfilGerenciaGeneralID,
		]
	
		return perfilesPermitidos.indexOf(this.authService.user.perfil) != -1
	}
  toggleText(){
    this.todoSelect = !this.todoSelect
    this.toggleCheckAll()
  }

  toggleCheckAll(){
    this.listSelect = []
      if(this.todoSelect){
          this.preselected = this.rowData.map((item) => { return item.id })
          this.listSelect = this.rowData
      } else {
          this.preselected = []
      }
  }

  evalCheck(){
    this.todoSelect = this.listSelect.length == this.rowData.length
  }


}
